import { render, staticRenderFns } from "./PortalRelatorios.vue?vue&type=template&id=3732f10f&"
import script from "./PortalRelatorios.vue?vue&type=script&lang=js&"
export * from "./PortalRelatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports